import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";
import { preparePopupGraphData } from "./quotaModificationUtils";

export default function MultilineChart() {
	const state = useSelector((store) => store.quotaModification);
	const { popupGraphData } = state;
   const [graphData, setGraphData] = useState({
      periods: [], 
      seriesData: [],
	  colors: []
   });
   
   useEffect(() => {
      const data = preparePopupGraphData(popupGraphData);
      setGraphData({
         ...state,
         periods: data.periods,
         seriesData: data.seriesData,
		 colors : data.color
      });
   }, []);

	const options = {
		title: {
			text: `Data Sources`,
			align: "left",
		},
		tooltip: {
			y: {
			  formatter: (value) => {
				const formatter = new Intl.NumberFormat("en-US");
				return formatter.format(value);
			  },
			},
		},
		xaxis: {
			categories: [...graphData.periods],
		},
		yaxis: {
			labels: {
			  formatter: (value) => {
				const formatter = new Intl.NumberFormat("en-US");
				return formatter.format(value);
			  },
			},
		},
		stroke: {
			width: 3,
         curve: "smooth"
		},
		markers: {
			size: 5,
		},
		colors: graphData.colors,
	};
	const series = [...graphData.seriesData];

	return (
		<Box>
			<Chart
				options={options}
				series={series}
				type="line"
				height={500}
				width={780}
			/>
		</Box>
	);
}
